import {useEffect} from 'react';
import useTracking from '@src/Tracking/useTracking';
import {TraceTokEvents} from '@src/Tracking/catalog';
import {IVodItemFragmentFragment} from '@src/Api/Graphql/gql/types.generated';

export function useVodTracking(vodItem?: IVodItemFragmentFragment) {
  const {emit} = useTracking();
  useEffect(() => {
    if (vodItem) {
      // content_detail_viewed (canonical)
      emit(TraceTokEvents.ContentDetailViewed, {
        content_id: vodItem.id,
        content_type: 'VODItem',
        placement: 'detail_page',
      });
    }
  }, [vodItem, emit]);
}
